<div class="mb-2" *ngIf="product.name !== undefined && product.name !== ''">
  <h4 class="pl-1 title" attr.title="{{ product.name }}">
    {{ product.name }}
    <i class="travel-icon icon-star" aria-hidden="true" *ngFor="let Star of starsArr; let Si = index"></i>
  </h4>
  <div class="clearfix"></div>
  <small *ngIf="product.address" class="pl-1 address">{{ product.address }}</small>
  <div class="clearfix"></div>
</div>
